/* global $ */
import intl from 'react-intl-universal'
export default ['$routeParams', StoryNotFoundController]

function StoryNotFoundController($routeParams) {
  this.storyId = $routeParams.id
  this.intl = intl
}
